<template lang="pug">
.bounty-record-container(
  v-infinite-scroll="load",
  infinite-scroll-disabled="loading",
  infinite-scroll-distance="10"
)
  template(v-if="!empty")
    .info
      .info-body
        .text 余额 :&nbsp;&nbsp;
        .amount {{ points }}
    .tabs
      .tab-headers
        .tab-header-item(
          v-for="(item, index) in options",
          :class="{ selected: selected == index }",
          @click="changeTab(index)"
        ) {{ item.name }}
      .tab-content
        template(v-if="options[selected].data.length")
          template(v-for="(list, index) in options")
            .list(v-if="selected == index")
              template
                .list-item(v-for="item in list.data")
                  template(v-if="item.placeholder")
                    .list-item-holder 请稍等...
                  template(v-else)
                    .list-item-left
                      .list-item-title {{ item.title }}
                      .list-item-subtitle {{ item.subtitle }}
                    .list-item-right
                      .list-item-desc {{ item.desc }}
        template(v-else)
          empty(:text="options[selected].text", @click="emptyClick(selected)")
    .hint
      .line &nbsp;
      .hint-text 仅展示近3个月内明细
      .line &nbsp;
  template(v-else)
    .page-empty
      empty(@click="emptyClick()")
</template>

<script>
/* eslint-disable no-nested-ternary */
import dayjs from 'dayjs';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { Native } from '@hb/NBridge/lib/h5';
import { InfiniteScroll } from 'mint-ui';
import Toast from '@/components/toast';
import Empty from './components/empty.vue';
import { getTokenAndKey } from '../../utils/index';
import {
  getBountyEarnRecords, getBountyConsumeRecords, getBountyExpiredRecords, getBountyBasicInfo,
} from '../../api/bounty';

let lastTime = new Date().getTime();
// tab类型
const SELECTED_TAB_TYPE = {
  INCOME: 0,
  EXPEND: 1,
  OVERDUE: 2,
};

export default {
  components: {
    Empty,
  },
  directives: {
    InfiniteScroll,
  },
  data() {
    return {
      signal: ['+', '-', '-'],
      points: 0,
      selected: 0,
      options: [
        {
          name: '收入',
          hasMore: true,
          pageIndex: 1,
          loading: true,
          text: '最近没有获得过奖励金，奖励金可兑换超值权益哦',
          virgin: true,
          data: [
            { placeholder: true },
            // DEFAULT_LIST_ITEM(),
            // DEFAULT_LIST_ITEM(), DEFAULT_LIST_ITEM(), DEFAULT_LIST_ITEM(),
            // DEFAULT_LIST_ITEM(),
            // DEFAULT_LIST_ITEM(),
            // DEFAULT_LIST_ITEM(),
            // DEFAULT_LIST_ITEM(),
          ],
          api: getBountyEarnRecords,
        },
        {
          name: '使用',
          hasMore: false,
          pageIndex: 1,
          loading: true,
          virgin: true,
          text: '最近没有支出过奖励金，奖励金可兑换超值权益哦',
          api: getBountyConsumeRecords,
          data: [
            { placeholder: true },
          ],
        },
        {
          name: '过期',
          hasMore: false,
          pageIndex: 1,
          loading: true,
          virgin: true,
          text: '最近没有过期的奖励金，奖励金可兑换超值权益哦',
          api: getBountyExpiredRecords,
          data: [
            // DEFAULT_LIST_ITEM(), DEFAULT_LIST_ITEM()
          ],
        },
      ],
    };
  },
  computed: {
    loading() {
      return this.options.every((v) => v.loading);
    },
    empty() {
      return false;
      // return this.options[0].data.filter((v) => !v.empty).length > 0;
      // return Number(this.points) === 0;
    },
  },
  async created() {
    const { points, selectedTab } = this.$route.query;

    // 默认选中tab逻辑
    if (selectedTab) {
      const anchorTab = SELECTED_TAB_TYPE[selectedTab];
      this.selected = anchorTab;
    }

    if (points !== undefined) {
      this.points = points;
    } else {
      const { token } = await getTokenAndKey();
      const basic = await getBountyBasicInfo({ token, pointType: 1 }).then((v) => v.data)
        .catch(() => null);
      if (basic) {
        this.points = basic.points || 0;
      }
    }
  },
  mounted() {
    UBT.pageView({
      pageId: 'Bonus_detailed',
      categoryId: 'platform',
      businessInfo: {},
    });
    if (!this.empty) {
      this.init();
    }
  },

  methods: {
    async load() {
      const item = this.options[this.selected];
      if (!item.hasMore || item.loading) return;
      if ((Date.now() - lastTime) < 100) {
        return;
      }
      // console.log('load');
      lastTime = Date.now();
      const { token } = await getTokenAndKey();
      item.api({
        token,
        pageSize: 10,
        pageIndex: item.pageIndex,
        pointType: 1,
      }).then((res) => this.handleData(res, this.selected));
    },
    async init() {
      if (!await Native.isLogin()) {
        Toast.show('您还没有登录');
        this.options.forEach((_, i) => {
          this.options[i].loading = false;
          this.options[i].data = [];
        });
        return;
      }
      const { token } = await getTokenAndKey();
      const a = getBountyEarnRecords({
        token,
        pageIndex: 1,
        pageSize: 10,
        pointType: 1,
      }).then((res) => this.handleData(res, 0));
      const b = getBountyConsumeRecords({
        token,
        pageIndex: 1,
        pageSize: 10,
        pointType: 1,
        consumerStatusList: [1, 2],
      }).then((res) => this.handleData(res, 1));
      const c = getBountyExpiredRecords({
        token,
        pageIndex: 1,
        pageSize: 10,
        pointType: 1,
      }).then((res) => this.handleData(res, 2));
      try {
        await a;
        await b;
        await c;
      } catch (e) {
        if (e && e.message) {
          Toast.show(e.message);
        }
      }
    },
    handleData(res, index) {
      if (!res || !res.data) {
        this.options[index].hasMore = false;
        return;
      }
      let data = [];

      if (index !== 2) {
        data = res.data.data;
      } else {
        data = res.data;
      }
      this.options[index].loading = false;
      // console.log('handleData', res.data.data.length);
      if (data.length < 10) {
        this.options[index].hasMore = false;
      } else {
        this.options[index].hasMore = true;
        this.options[index].pageIndex += 1;
      }
      const records = data.map((v) => {
        const {
          issueTime, consumeTime, expireTime, points, pointName, remark,
        } = v;
        const subtitle = dayjs(
          index === 0 ? issueTime : index === 1 ? consumeTime : expireTime,
        ).format('YYYY-MM-DD HH:mm');
        return {
          title: index === 0 ? pointName : index === 1 ? remark : '过期失效',
          subtitle,
          desc: `${this.signal[index]}${points}`,
        };
      });
      if (this.options[index].virgin) {
        this.options[index].virgin = false;
        this.options[index].data = records;
      } else {
        this.options[index].data = this.options[index].data.concat(records);
      }
    },
    emptyClick(index = 0) {
      UBT.clickButton({
        pageId: 'Bonus_detailed',
        buttonName: 'Detailed_see',
        categoryId: 'platform',
        businessInfo: {
          Click_source: `${index}`,
        },
      });
      this.$router.go(-1);
    },
    changeTab(index) {
      if (this.loading) {
        return;
      }
      UBT.clickButton({
        pageId: 'Bonus_detailed',
        buttonName: (['Detailed_income', 'Detailed_use', 'Detailed_overdue'])[index],
        categoryId: 'platform',
        businessInfo: { },
      });
      if (this.selected !== index) {
        this.selected = index;
      }
    },
  },
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}

.bounty-record-container {
  background-color: rgba(244, 244, 244, 1);
  min-height: 100%;

  .page-empty {
    background-color: rgba(244, 244, 244, 1);
    width: 100%;
    // height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  .info {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 1.38rem;
    background-color: rgba(0, 136, 255, 1);
    background-image: url(https://m.hellobike.com/resource/AppPlatformH5/bounty/JvQzqa9aLvLEMMhf6RhCV.png);
    background-size: 100% 100%;

    .info-body {
      display: flex;
      align-items: flex-end;
      justify-content: center;
      margin-top: -0.4rem;

      .text {
        font-size: 0.12rem;
        color: rgba(255, 255, 255, 1);
        line-height: 0.26rem;
      }

      .amount {
        font-size: 0.38rem;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        line-height: 0.44rem;
        transform: scaleX(0.9);
        font-family: "DIN Alternate Bold", sans-serif;
      }
    }
  }

  .tabs {
    margin: -0.38rem 0.12rem 0;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 0.03rem 0.06rem 0 rgba(0, 0, 0, 0.06);
    border-radius: 0.08rem;
    overflow: hidden;

    .tab-headers {
      height: 0.5rem;
      border-bottom: 0.01rem rgba(238, 238, 238, 0.5) solid;
      position: relative;
      display: flex;
      justify-content: space-between;

      .tab-header-item {
        height: 100%;
        font-size: 0.15rem;
        color: rgba(153, 153, 153, 1);
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;
        position: relative;

        &::after {
          content: "";
          display: block;
          position: absolute;
          left: 50%;
          bottom: 0;
          transform: translateX(-50%);
          background-color: rgba(0, 136, 255, 1);
          width: 0;
          height: 0.03rem;
          transition: width 0.2s ease-in-out;
        }

        &.selected {
          color: rgba(51, 51, 51, 1);

          &::after {
            width: 0.32rem;
          }
        }
      }
    }

    .list {
      padding: 0.09rem 0 0.09rem 0.15rem;

      .list-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.14rem 0.15rem 0.14rem 0;

        &:not(:last-of-type) {
          border-bottom: solid 0.01rem rgba(238, 238, 238, 1);
        }

        .list-item-holder {
          display: inline-block;
          text-align: center;
          width: 100%;
          font-size: 0.12rem;
          color: #999;
        }

        .list-item.left {
          display: flex;
          flex-direction: column;
          flex: 1;
        }

        .list-item-title {
          font-size: 0.14rem;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          margin-bottom: 0.03rem;
          white-space: nowrap;
          max-width: 2.8rem;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        .list-item-subtitle {
          font-size: 0.12rem;
          color: rgba(153, 153, 153, 1);
        }

        .list-item-desc {
          font-size: 0.14rem;
          font-weight: bold;
          color: rgba(102, 102, 102, 1);
        }
      }
    }
  }

  .hint {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0.33rem;

    .line {
      width: 0.4rem;
      height: 0.01rem;
      background-color: rgba(221, 221, 221, 1);
    }

    .hint-text {
      margin: 0 0.13rem;
      font-size: 0.12rem;
      color: rgba(204, 204, 204, 1);
    }
  }
}
</style>
